// extracted by mini-css-extract-plugin
export default {"my_btn":"CustomBtnTransparent_my_btn__sTzQc"};